// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"a5b68684","387":"11553dcc","423":"11553dcc","475":"1c0e3640","690":"11553dcc","768":"11553dcc","891":"11553dcc","998":"11553dcc"}[chunkId] + ".chunk.css";
};